export function createTokenChannel(onNewToken) {
  const channel = new BroadcastChannel('auth_channel');

  channel.onmessage = (event) => {
    if (event.data.type === 'NEW_ACCESS_TOKEN') {
      onNewToken(event.data.token);
    }
  };

  return channel;
}
